import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * @email WY <yang.wang06@hand-china.com>
 * @creationDate 2019/12/25
 * @copyright HAND ® 2019
 */
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import { getCurrentOrganizationId, isTenantRoleLevel } from "../../utils/utils";
var _getEnvConfig = getEnvConfig(),
  HZERO_IAM = _getEnvConfig.HZERO_IAM,
  HZERO_MNT = _getEnvConfig.HZERO_MNT,
  HZERO_PLATFORM = _getEnvConfig.HZERO_PLATFORM; // import { getCurrentOrganizationId, isTenantRoleLevel } from '@/utils/utils';
// /**
//  * 获取菜单对应的权限集
//  * @param {string} params.service - 权限编码
//  */
// export async function getPermission(params) {
//   const organizationId = getCurrentOrganizationId();
//   return request(
//     `${HZERO_IAM}/hzero/v1/${isTenantRoleLevel() ? `${organizationId}/` : ''}menus/buttons`,
//     {
//       query: { ...params },
//       method: 'GET',
//     }
//   );
// }

/**
 * 检验权限
 * @param {array} params.code - 权限编码
 */

export function checkPermission(_x) {
  return _checkPermission.apply(this, arguments);
}
/**
 * 检验权限
 * @param {array} params.code - 权限编码
 */

function _checkPermission() {
  _checkPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", request("".concat(HZERO_IAM, "/hzero/v1/menus/check-permissions"), {
              method: 'POST',
              body: params
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkPermission.apply(this, arguments);
}
export function checkHistoryLog(_x2) {
  return _checkHistoryLog.apply(this, arguments);
}
/**
 * 查询导航栏配置
 */

function _checkHistoryLog() {
  _checkHistoryLog = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", request("".concat(HZERO_MNT, "/v1/").concat(getCurrentOrganizationId(), "/audit-documents/page-route"), {
              method: 'GET',
              query: _objectSpread({}, params, {
                pageRoute: isTenantRoleLevel() ? params.pageRoute : 'site:'.concat(params.pageRoute)
              })
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkHistoryLog.apply(this, arguments);
}
export function checkEntryDirectory() {
  return _checkEntryDirectory.apply(this, arguments);
}
function _checkEntryDirectory() {
  _checkEntryDirectory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "quick-entry/map-list"), {
              method: 'GET'
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _checkEntryDirectory.apply(this, arguments);
}